import { CancelInteracMoneyRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useCancelInteracBulkPayout({ bearer }: { bearer?: string }) {
  const [fetching, setFetching] = useState(false);

  async function cancelInteracBulkPayout(params: CancelInteracMoneyRequest) {
    try {
      setFetching(true);
      const res = await api.postCancelInteracBulkPayout(params, bearer);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, cancelInteracBulkPayout };
}
